export const common = {
  welcome: '환영합니다',
  home: '홈',
  about: '회사 소개',
  services: '서비스',
  contact: '문의하기',
  learnMore: '자세히 보기',
  getStarted: '시작하기',
  submit: '제출',
  cancel: '취소',
  close: '닫기',
  save: '저장',
  edit: '편집',
  delete: '삭제',
  search: '검색',
  loading: '로딩 중...',
  error: '오류가 발생했습니다',
  success: '성공',
  reserveNow: '지금 예약',
};